import React, { useState, useEffect } from "react";
import DashboardInfluenceur from "../components/Influenceur/DashboardInfluenceur";
import ClientsInfluenceur from "../components/Influenceur/ClientsInfluenceur";
import CommissionsInfluenceur from "../components/Influenceur/CommissionsInfluenceur";
import CompteInfluenceur from "../components/Influenceur/CompteInfluenceur";
import { TiHome } from "react-icons/ti";
import { IoPerson } from "react-icons/io5";
import { BsPeople, BsCashStack } from "react-icons/bs";
import logo from "../assets/logo.png";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EspaceInfluenceur = () => {
  const [activeTab, setActiveTab] = useState("Dashboard");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const tabs = [
    { label: "Dashboard", icon: TiHome, component: <DashboardInfluenceur /> },
    { label: "Clients", icon: BsPeople, component: <ClientsInfluenceur /> },
    { label: "Commissions", icon: BsCashStack, component: <CommissionsInfluenceur /> },
    { label: "Compte", icon: IoPerson, component: <CompteInfluenceur /> },
  ];

  const renderContent = () => {
    const tab = tabs.find((t) => t.label === activeTab);
    return tab ? tab.component : null;
  };

  return (
    <div className="flex flex-col h-screen w-full bg-color2">
      {/* Toast */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Desktop filter bar */}
      {!isMobile && (
        <div className="fixed top-0 left-1/2 transform -translate-x-1/2 z-50 flex justify-center gap-4 py-2 px-4 shadow-md rounded-b-3xl bg-color2">
          {tabs.map((tab) => (
            <button
              key={tab.label}
              onClick={() => setActiveTab(tab.label)}
              className={`flex items-center gap-2 px-4 py-2 rounded-3xl font-semibold transition
            ${activeTab === tab.label ? "bg-color3 text-white" : "text-color1 hover:bg-color3 hover:text-color2"}
          `}
            >
              <tab.icon size={20} />
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      )}

      {/* Main content */}
      <div
        className={`flex justify-center w-full overflow-auto px-4 py-4 bg-color2
      ${isMobile ? "pt-4 pb-32" : "pt-16 lg:pb-0 pb-24"}`}
      >
        <div className="w-full max-w-6xl text-center">{renderContent()}</div>
      </div>

      {/* Mobile bottom bar */}
      {isMobile && (
        <div className="fixed bottom-0 left-0 w-full bg-color1 border-t shadow-inner flex justify-around py-2 z-50">
          {tabs.map((tab) => (
            <button
              key={tab.label}
              onClick={() => setActiveTab(tab.label)}
              className={`flex flex-col items-center text-xs ${activeTab === tab.label ? "text-color3" : "text-color2"
                }`}
            >
              <tab.icon size={24} />
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>

  );
};

export default EspaceInfluenceur;
